<template>
  <div style="position: relative">
    <v-text-field
      placeholder="Cautare"
      hint="Se cauta dupa simbol si observatii"
      clearable
      persistent-hint
      append-icon="mdi-magnify"
      solo
      :loading="loading"
      single-line
      @click:append="_cbSearch"
      @keydown.enter="_cbSearch"
      :suffix="total"
      v-model="searchTerm">
    </v-text-field>
    <v-list three-line dense>
      <v-subheader>
        Simboluri

        <v-scale-transition appear group>
          <template v-if="user && user.admin">
            <v-btn icon @click.stop="uplaodXLSX" color="primary" flat key="xlsx" title="Upload simboluri din xlsx">
              <v-icon>mdi-file-upload</v-icon>
            </v-btn>
          </template>

          <v-avatar size="18" class="mx-1" @click="toggleFilter('eligibile ')" key="el" :title="filters.includes('eligibile ') ? 'Eligibile vizibile' : 'Eligibile ascunse'">
            <v-img
              src="/svg/eligibile/square.svg"
              :gradient="
                filters.includes('eligibile ') ? '' : 'to right, rgba(173,173,173,0.65) 0%,rgba(173,173,173,0.65) 100%'">
            </v-img>
          </v-avatar>
          <v-avatar size="18" class="mx-1" @click="toggleFilter('partial eligibile ')" key="pel">
            <v-img
              src="/svg/partial_eligibile/circle.svg"
              :gradient="
                filters.includes('partial eligibile ') ? '' : 'to right, rgba(173,173,173,0.65) 0%,rgba(173,173,173,0.65) 100%'" :title="filters.includes('partial eligibile ') ? 'Partial Eligibile vizibile' : 'Partial Eligibile ascunse'">
            </v-img>
          </v-avatar>
          <v-avatar size="18" class="mx-1" @click="toggleFilter('posibil eligibile')" key="ppel" :title="filters.includes('posibil eligibile') ? 'Posibil Eligibile vizibile' : 'Posibil Eligibile ascunse'">
            <v-img
              src="/svg/posibil_eligibile/diamond.svg"
              :gradient="
                filters.includes('posibil eligibile') ? '' : 'to right, rgba(173,173,173,0.65) 0%,rgba(173,173,173,0.65) 100%'">
            </v-img>
          </v-avatar>
          <v-avatar size="18" class="mx-1" @click="toggleFilter('Partial&Posibil Eligibile')" key="pnpel" :title="filters.includes('Partial&Posibil Eligibile') ? 'Partial&Posibil Eligibile vizibile' : 'Partial&Posibil Eligibile ascunse'">
            <v-img
              src="/svg/partial_posibil_eligibile/pentagon.svg"
              :gradient="
                filters.includes('Partial&Posibil Eligibile') ? '' : 'to right, rgba(173,173,173,0.65) 0%,rgba(173,173,173,0.65) 100%'">
            </v-img>
          </v-avatar>

          <v-avatar size="18" class="mx-1" @click="toggleDone" key="tohhle-done" :title="done === null ? 'Done si Not Done' : (done === 1 ? 'Done' : 'Not Done')">
            <v-icon :color="doneColor" :size="20">
              {{done === null ? 'mdi-check-circle-outline' : (done === 1 ? 'mdi-check-circle' : 'mdi-close-circle')}}
            </v-icon>
          </v-avatar>

          <v-avatar size="18" class="mx-1" @click="togglePhotos" key="toggle-photos" :title="photos === null ? 'Cu si Fara Poze' : (photos === 1 ? 'Cu Poze' : 'Fara Poze')">
            <v-icon :color="photosColor" :size="20">
              {{photos === null ? 'mdi-camera-outline' : (photos === 1 ? 'mdi-camera' : 'mdi-camera-off')}}
            </v-icon>
          </v-avatar>

          <v-avatar size="18" class="mx-1" @click="togglePdfs" key="toggle-pdfs" :title="pdfs === null ? 'Cu si Fara Pdf-uri' : (pdfs === 1 ? 'Cu Pdf-uri' : 'Fara Pdf-uri')">
            <v-icon :color="pdfsColor" :size="20">
              {{pdfs === null ? 'mdi-file-pdf-outline' : (pdfs === 1 ? 'mdi-file-pdf' : 'mdi-file-pdf')}}
            </v-icon>
          </v-avatar>

          <template>
            <v-btn icon @click.stop="_cbAddEntity" color="primary" flat key="add" title="Adauga manual un simbol">
              <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
          </template>
        </v-scale-transition>

      </v-subheader>

      <v-subheader class="mb-2">
        Eticheta:
         <v-chip color="primary" text-color="white" @click="openLabelsDialog" close @input="resetLabel">
           <v-icon>mdi-filter</v-icon>
          {{ selectedLabel === null ? 'Toate' : (selectedLabel === undefined ? 'Undefined' : selectedLabel) }}
         </v-chip>
      </v-subheader>
      <!-- <v-list-tile v-for="item in items" :key="item._id" v-touch="{ end: (wrapper) => _cbSwipe(wrapper) }"> -->
      <template v-for="item in items">
        <v-list-tile :key="item._id" class="mb-2" v-touch="{
          left: () => _cbNavigate('details', item),
          right: () => _cbNavigate('map', item),
        }">
          <v-list-tile-action @click="_cbNavigate('map', item)">
            <v-scale-transition appear>
              <v-avatar title="Mergi la harta">
                <v-img :src="getItemType(item)"></v-img>
              </v-avatar>
            </v-scale-transition>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{item.simbol}}
              <v-scale-transition appear group>
                <v-icon small v-if="item.done" color="primary" :key="item._id + 'done'" title="Done">mdi-check</v-icon>
                <v-icon small v-else color="error" :key="item._id + 'notdone'" title="Not done">mdi-close</v-icon>
                <v-icon small color="primary" v-if="item.photos.length" :key="item._id + 'photo-on'" title="Poze incarcate">mdi-image</v-icon>
                <v-icon small color="error" v-else :key="item._id + 'photo-off'" title="Nu exista poze incarcate">mdi-image-off</v-icon>
                <span :key="item._id + 'len'">{{item.photos.length}}</span>
              </v-scale-transition>
              <v-scale-transition appear group>
                <v-icon small color="primary" v-if="item.pdfs.length" :key="item._id + 'pdf-on'" title="Pdf-uri incarcate">mdi-file-pdf</v-icon>
                <v-icon small color="error" v-else :key="item._id + 'pdf-off'" title="Nu exista pdf-uri incarcate">mdi-file-pdf</v-icon>
                <span :key="item._id + 'len'">{{item.pdfs.length}}</span>
              </v-scale-transition>
              <v-scale-transition appear group>
                <v-icon class="ml-1" small :color="filesInQueue(item._id) ? 'primary' : 'blue-grey'" :key="item._id + 'up'" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                <span class="ml-1" :key="item._id + 'lenq'">{{filesInQueue(item._id)}}</span>
              </v-scale-transition>
            </v-list-tile-title>
            <v-list-tile-sub-title>{{item.observatii_birou}}</v-list-tile-sub-title>
            <v-list-tile-sub-title>{{item.observatii_teren}}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action @click="_cbNavigate('details', item)">
            <v-scale-transition appear>
              <v-icon large title="Mergi la detalii">mdi-format-list-bulleted-type</v-icon>
            </v-scale-transition>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider :key="item._id + '_divider'"></v-divider>
      </template>

      <v-list-tile>
        <v-list-tile-content>
          <div class="d-flex" style="width: 100%">
            <v-spacer></v-spacer>
            <v-pagination
              style="justify-content: center"
              v-model="page"
              :length="totalPages"
              circle
            ></v-pagination>
            <v-spacer></v-spacer>
          </div>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-dialog v-model="dialog" persistent max-width="80vw">
      <v-card flat>
        <v-card-title>Incarcare XLSX cu simboluri</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="label"
            label="Eticheta"
            hint="Eticheta aplicata simbolurilor ce urmeaza a fi incarcate">
          </v-text-field>
          <form ref="form">
            <input type="file" ref="fileinput" accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeDialog" :disabled="uploading">Renunta</v-btn>
          <v-btn flat color="primary" @click="filesAdded" :loading="uploading" :disabled="uploading">Incarca</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="labelsDialog" persistent max-width="80vw">
      <v-card flat>
        <v-card-title>Filtrare simboluri dupa eticheta</v-card-title>
        <v-card-text>
          <v-radio-group v-model="selectedLabel">
            <v-radio
              v-for="label in labels"
              :key="label.label + label.data"
              :label="`${label.label} (${label.data})`"
              :value="label.label"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="closeLabelsDialog">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addDialog" persistent scrollable>
      <v-card flat>
        <v-card-title>Adaugare simbol</v-card-title>
        <v-card-text>
          <v-form ref="addForm" v-model="addFormValid" lazy-validation>
            <template v-for="field in fields">
              <template v-if="getType(field.value)">
                <v-select
                  v-if="getType(field.value) === 'select' && field.value === 'sheet'"
                  :items="['eligibile ', 'partial eligibile ', 'posibil eligibile', 'Partial&Posibil Eligibile']"
                  label="Sheet"
                  :key="field.value"
                  v-model="newEntity[field.value]"
                  :rules="getRules(field.value)">
                </v-select>
                <v-select
                  v-if="getType(field.value) === 'select' && field.value === 'eticheta'"
                  :items="labelsText"
                  label="Eticheta"
                  :key="field.value"
                  v-model="newEntity[field.value]"
                  :rules="getRules(field.value)">
                </v-select>
                <v-text-field
                  class="my-3"
                  v-if="['text', 'number'].includes(getType(field.value))"
                  :key="field.value"
                  :type="getType(field.value)"
                  v-model.number="newEntity[field.value]"
                  :label="field.label"
                  :rules="getRules(field.value)">
                </v-text-field>
                <v-textarea
                  class="my-3"
                  v-if="['textarea'].includes(getType(field.value))"
                  :key="field.value"
                  v-model="newEntity[field.value]"
                  auto-grow
                  :rows="1"
                  :label="field.label"
                  :rules="getRules(field.value)">
                </v-textarea>
                <v-switch
                  v-if="['boolean'].includes(getType(field.value))"
                  :key="field.value"
                  v-model="newEntity[field.value]"
                  :label="field.label"
                ></v-switch>
                <div style="width: 100%; height: 50vh" v-if="getType(field.value) === 'map'" :key="field.value">
                  <GmapMap
                    :center="mapCenter"
                    :zoom="zoom"
                    :map-type-id="mapType"
                    :style="{ width: '100%', height: '100%' }"
                    ref="map">

                    <GmapMarker
                      :position="mapCenter"
                      :draggable="true"
                      @position_changed="_cbPositionChanged" />

                  </GmapMap>
                </div>
              </template>
            </template>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeAddDialog(0)">Renunta</v-btn>
          <v-btn flat color="primary" @click="closeAddDialog(1)">Salveaza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'

export default {
  name: 'entities',
  data: () => ({
    search: '',
    dialog: false,
    label: null,
    uploading: false,
    labelsDialog: false,
    addDialog: false,
    addFormValid: true,
    newEntity: {}
  }),
  computed: {
    searchTerm: {
      get () {
        return this.$store.getters['entities/search']
      },
      set (value) {
        this.search = value
        if (!value) {
          this._cbSearch()
        }
      }
    },
    user () {
      return this.$store.getters.user
    },
    items () {
      return this.$store.getters['entities/items']
    },
    total () {
      return String(this.$store.getters['entities/total'])
    },
    page: {
      get () {
        return this.$store.getters['entities/page']
      },
      set (value) {
        this.$store.dispatch('entities/setPage', value)
      }
    },
    totalPages () {
      return this.$store.getters['entities/totalPages']
    },
    filters () {
      return this.$store.getters['entities/filters']
    },
    done () {
      return this.$store.getters['entities/done']
    },
    photos () {
      return this.$store.getters['entities/photos']
    },
    pdfs () {
      return this.$store.getters['entities/pdfs']
    },
    doneColor () {
      if (this.done === 1) return 'primary'
      if (this.done === -1) return 'error'
      return 'blue-grey'
    },
    photosColor () {
      if (this.photos === 1) return 'primary'
      if (this.photos === -1) return 'error'
      return 'blue-grey'
    },
    pdfsColor () {
      if (this.pdfs === 1) return 'primary'
      if (this.pdfs === -1) return 'error'
      return 'blue-grey'
    },
    loading () {
      return this.$store.getters.loading
    },
    files () {
      return this.$store.getters['entities/files']
    },
    labels () {
      return this.$store.getters['entities/labels']
    },
    selectedLabel: {
      get () {
        return this.$store.getters['entities/selectedLabel']
      },
      set (value) {
        this.$store.commit('entities/setSelectedLabel', value)
        this.$store.dispatch('entities/fetchEntities')
      }
    },

    fields () {
      if (this.items[0]) {
        return Object.keys(this.items[0])
          .filter(field => {
            return !['_id', 'createdAt', 'updatedAt', '__v', 'done'].includes(field)
          })
          .sort((a, b) => compare(a, b))
          .map(field => {
            this.$set(this.newEntity, field, null)
            return {
              label: field.replace(/_/g, ' ').toUpperCase(),
              value: field
            }
          })
      } else {
        return ['_id', 'eticheta', 'sheet', 'simbol', 'photos', 'done', 'observatii_teren', 'locuri_teren', 'calupuri_teren', 'centru_geometric', 'observatii_birou', 'locuri', 'carou', 'tip', 'poligon', 'numar_poligoane', 'suprafata_m2', 'in_vecinatatea_simbolului', 'eligibil', 'partial_eligibil', 'posibil_eligibil']
      }
    },
    mapCenter () {
      return this.$store.getters.mapCenter
    },
    zoom () {
      return this.$store.getters.zoom
    },
    mapType () {
      return this.$store.getters.mapType
    },
    labelsText () {
      return this.$store.getters['entities/labels'].map(label => label.label)
    }
  },
  methods: {
    resetLabel () {
      this.selectedLabel = null
    },
    openLabelsDialog () {
      this.labelsDialog = true
    },
    closeLabelsDialog () {
      this.labelsDialog = false
    },
    closeDialog () {
      this.dialog = false
      this.label = null
      this.$refs.form.reset()
    },
    filesInQueue (entity) {
      return this.files.filter(file => file.entity === entity && !file.uploaded).length
    },
    toggleDone () {
      this.$store.dispatch('entities/toggleDone')
    },
    togglePhotos () {
      this.$store.dispatch('entities/togglePhotos')
    },
    togglePdfs () {
      this.$store.dispatch('entities/togglePdfs')
    },
    toggleFilter (filter) {
      this.$store.dispatch('entities/toggleFilter', filter)
    },
    getItemType (marker) {
      switch (marker.sheet) {
        case 'eligibile ': return marker.done ? '/svg/eligibile/square_done.svg' : '/svg/eligibile/square.svg'
        case 'partial eligibile ': return marker.done ? '/svg/partial_eligibile/circle_done.svg' : '/svg/partial_eligibile/circle.svg'
        case 'Partial&Posibil Eligibile': return marker.done ? '/svg/partial_posibil_eligibile/pentagon_done.svg' : '/svg/partial_posibil_eligibile/pentagon.svg'
        case 'posibil eligibile': return marker.done ? '/svg/posibil_eligibile/diamond_done.svg' : '/svg/posibil_eligibile/diamond.svg'
      }
    },
    _cbNavigate (where, entity) {
      if (where === 'map') {
        this.$store.commit('setMapCenter', entity.centru_geometric)
        this.$store.commit('setZoom', 17)
      }
      this.$router.push({ name: where, params: { entity: entity._id } })
    },
    _cbSearch () {
      this.$nextTick(() => {
        this.$store.dispatch('entities/search', this.search)
      })
    },
    uplaodXLSX () {
      this.dialog = true
      // this.$refs.fileinput.click()
    },
    filesAdded () {
      if (!this.$refs.fileinput.files.length) return

      this.$store.commit('setLoading', true)
      this.uploading = true

      let file = this.$refs.fileinput.files[0]

      try {
        let fileReader = new FileReader()
        /* eslint-disable handle-callback-err */
        fileReader.onload = event => {
          this.$store.dispatch('entities/uploadXLSX', {
            buffer: event.target.result,
            label: this.label
          }).then((res) => {
            this.$store.commit('setLoading', false)
            this.uploading = false
            this.$refs.form.reset()
            this.label = null
            this.dialog = false
          }).catch(error => {
            this.$store.commit('setLoading', false)
            this.uploading = false
            this.$refs.form.reset()
            this.label = null
            this.dialog = false
            alert('Whoops! Whoopsie! Ceva nu a functionat...')
          })
        }
        fileReader.readAsDataURL(file)
        // console.log(photos)
      } catch (err) {
        this.$store.commit('setLoading', false)
        this.uploading = false
        this.$refs.form.reset()
        this.label = null
        this.dialog = false
        alert('Dispozitivul d-voastra nu suporta aceasta functie.')
      }
    },

    _cbAddEntity () {
      this.addDialog = true
    },
    closeAddDialog (mode) {
      if (mode) {
        if (!this.$refs.addForm.validate()) return
        this.addDialog = false
        this.$refs.addForm.resetValidation()
        // tip must be 'Simbol'
        // photo must be an array
        // done must be false
        // cast everything else to String

        const obj2save = {}

        Object.keys(this.newEntity).forEach(key => {
          switch (this.getType(key)) {
            case 'boolean': obj2save[key] = this.newEntity[key] === true ? 'Da' : (this.newEntity[key] === false ? 'Nu' : null); break
            case 'map': obj2save[key] = this.newEntity[key] ? { ...this.newEntity[key] } : null; break
            default: obj2save[key] = this.newEntity[key] === null ? null : String(this.newEntity[key])
          }

          this.newEntity[key] = null
        })

        if (JSON.stringify(this.newEntity) !== JSON.stringify(obj2save)) {
          obj2save.done = false
          obj2save.tip = 'Simbol'
          obj2save.photos = []

          this.$store.state.services.entities.create(obj2save)
        }
      } else {
        this.addDialog = false
        this.$refs.addForm.resetValidation()
      }
    },

    getType (fieldValue) {
      switch (fieldValue) {
        case 'eticheta': return 'select'
        case 'sheet': return 'select'
        case 'simbol': return 'text'
        case 'carou': return 'text'
        case 'poligon': return 'text'
        case 'in_vecinatatea_simbolului': return 'text'
        case 'observatii_teren': return 'textarea'
        case 'calupuri_teren': return 'textarea'
        case 'observatii_birou': return 'textarea'
        case 'locuri_teren': return 'number'
        case 'locuri': return 'number'
        case 'numar_poligoane': return 'number'
        case 'suprafata_m2': return 'number'
        case 'centru_geometric': return 'map'
        case 'eligibil': return 'boolean'
        case 'partial_eligibil': return 'boolean'
        case 'posibil_eligibil': return 'boolean'
        default: return false
      }
    },
    _cbPositionChanged: debounce(function ($event) {
      const pos = { lat: $event.lat(), lng: $event.lng() }
      this.$set(this.newEntity, 'centru_geometric', pos)
      this.$forceUpdate()
    }, 1000),
    getRules (fieldValue) {
      switch (fieldValue) {
        case 'sheet':
        case 'eticheta':
        case 'simbol': return [val => val === null ? 'Camp obligatoriu' : true]
        default: return []
      }
    }
  },
  mounted () {
    if (this.searchTerm) {
      this.search = this.searchTerm
    }
  }
}

const compare = (a, b) => {
  const fields = [
    '_id',
    'eticheta',
    'sheet',
    'simbol',
    'photos',
    'done',
    'observatii_teren',
    'locuri_teren',
    'calupuri_teren',
    'centru_geometric',
    'observatii_birou',
    'locuri',
    'carou',
    'tip',
    'poligon',
    'numar_poligoane',
    'suprafata_m2',
    'in_vecinatatea_simbolului',
    'eligibil',
    'partial_eligibil',
    'posibil_eligibil'
  ]

  return fields.findIndex(f => f === a) - fields.findIndex(f => f === b)
}
</script>

<style>

</style>
